import React from 'react';
import {
    OutliersPlType,
    plTypeText,
} from 'widgets/outliers/store/config/OutliersConfigState';
import { DropdownItemProps } from '@instinet-analytics/semantic-ui-components';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';

export interface OutliersPlTypeDropdownProps {
    value?: OutliersPlType;
    onChange: (nextValue: OutliersPlType | undefined) => void;
}

export function OutliersPlTypeDropdown(props: OutliersPlTypeDropdownProps) {
    const { value, onChange } = props;

    const plDropdownItem = (p: OutliersPlType) => ({
        value: p,
        key: p,
        text: plTypeText(p),
    });
    const options: DropdownItemProps[] = [
        plDropdownItem('realised'),
        plDropdownItem('unrealised'),
        plDropdownItem('total'),
    ];

    const onDropdownChange = (value: string | undefined) => {
        onChange(value as OutliersPlType);
    };

    return (
        <Dropdown
            className="OutliersPlTypeDropdown"
            options={options}
            value={value}
            onChange={onDropdownChange}
        />
    );
}
